import React from 'react';
import { Pressable, StyleSheet, Text, View } from 'react-native';
import Animated from 'react-native-reanimated';
import theme from 'theme';

import { useCollapseWithAnimation } from 'components/Collapse/animation';
import { Icons } from 'components/Icons';

export type CollapseProps = { title: string; content: string };

const Collapse: React.FC<CollapseProps> = ({ title, content }) => {
  const { animatedContainerStyle, isOpen, toggleCollapse, contentRef } = useCollapseWithAnimation();
  const headerTransparency = isOpen ? 25 : 10;

  return (
    <View style={styles.container}>
      <Pressable
        onPress={toggleCollapse}
        style={({ pressed }) => [
          styles.header,
          { backgroundColor: `${theme.colors.base.white}${headerTransparency}` },
          pressed && styles.headerPressed,
        ]}>
        <View style={styles.headerContent}>
          <Text style={styles.title} numberOfLines={1}>
            {title}
          </Text>
          {isOpen ? <Icons.ChevronUp /> : <Icons.ChevronDown />}
        </View>
      </Pressable>
      <Animated.View ref={contentRef} style={[styles.contentBox, animatedContainerStyle]}>
        <Text style={styles.contentText}>{content}</Text>
      </Animated.View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'column',
    gap: 8,
    paddingHorizontal: 16,
    width: '100%',
  },
  header: {
    paddingVertical: 16,
    paddingHorizontal: 16,
    borderRadius: 8,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 0,
  },
  headerPressed: {
    opacity: 0.8,
  },
  headerContent: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    flex: 1,
    gap: 4,
  },
  title: {
    flex: 1,
    color: theme.colors.base.white,
  },
  contentBox: {
    paddingHorizontal: 16,
    paddingVertical: 24,
    borderRadius: 8,
    elevation: 10,
    borderWidth: 1,
    shadowColor: '#fff',
    backgroundColor: theme.colors.base.darkBlue,
    borderColor: theme.colors.base.blue,
    width: '100%',
  },
  contentText: {
    color: theme.colors.base.white,
  },
});

export default Collapse;
